import {injectable} from "inversify";
import {Player} from "@/modules/team/entity";
import {Competition, CompetitionPlayerLog} from "@/modules/competitions/entity";
import {Season} from "@/modules/season/entity";

@injectable()
export default class CompetitionPlayerLogger {
  public async getLogs(players: Player[], competition: Competition) {
    return await CompetitionPlayerLog
      .createQueryBuilder('log')
      .innerJoin('log.competition', 'competition')
      .innerJoin('log.player', 'player')
      .innerJoin('log.season', 'season')
      .where('season.current = true AND competition.id = :competitionId', {competitionId: competition.id})
      .andWhere(`player.id IN (${players.map(p => p.id).join(',')})`)
      .getMany();
  }

  public async createLog(season: Season, player: Player, competition: Competition) {
    let log = await CompetitionPlayerLog
      .createQueryBuilder('log')
      .innerJoin('log.competition', 'competition')
      .innerJoin('log.player', 'player')
      .innerJoin('log.season', 'season')
      .where(
        'season.current = true AND player.id = :playerId AND competition.id = :competitionId',
        {
          playerId: player.id,
          competitionId: competition.id,
        }
      )
      .getOne();

    if (!log) {
      log = new CompetitionPlayerLog();
      log.player = player;
      log.competition = competition;
      log.season = season;
    }

    return log;
  }

  public async logByLog(log: CompetitionPlayerLog, goals: number, yellow: boolean, yellowRed: boolean, red: boolean) {
    log.matches = log.matches + 1;
    log.goals += goals;
    log.yellow += yellow ? 1 : 0;
    log.yellowRed += yellowRed ? 1 : 0;
    log.red += red ? 1 : 0;
    await log.save();

    return log;
  }

  public async log(season: Season, player: Player, competition: Competition, goals: number, yellow: boolean, yellowRed: boolean, red: boolean) {
    const log = await this.createLog(season, player, competition);

    return await this.logByLog(log, goals, yellow, yellowRed, red);
  }
}
